// Viloyat/tuman TANLOVI — kontakt formasi uchun. Faqat O'QISH.
//
//   GET /api/regions?activeOnly&size&sort
//   GET /api/districts?regionId&activeOnly&size&sort
//
// ⚠️ YOZISH YO'LI ATAYLAB YO'Q. Egasining qarori (SHARTNOMA-4 §A3):
// viloyat va tuman alohida CRUD, kontakt formasidan QO'SHIB BO'LMAYDI.
// «Ro'yxatda yo'q ekan, o'zim qo'shaman» yo'li ochilsa reestr bir hafta
// ichida bir viloyatning uch imlosidan iborat bo'lardi.
//
// ⚠️ `geo.read` SHERIK TO'PLAMIDA BOR-YO'QLIGI SHU PANELNING QARORI
// EMAS (`PartnerKind.java` — huquqlar KODDA qotirilgan, ADR-029 §2).
// Shuning uchun 403 XATO EMAS, HOLAT: chaqiruvchi «reestr yopiq» degan
// javob oladi va formada sabab ko'rinadi. Jimgina bo'sh ro'yxat
// ko'rsatish eng yomon variant bo'lardi — operator viloyatini qidirib
// topolmay, uni umuman yo'q deb o'ylardi.

import axios from 'axios'
import { z } from 'zod'
import { api } from '@/shared/api/client'
import { uuidSchema } from '@/shared/api/schemas'

export interface GeoOption {
  id: string
  name: string
}

export interface GeoOptions {
  options: readonly GeoOption[]
  /** Reestr chegaradan oshdi — ro'yxatda HAMMASI yo'q */
  truncated: boolean
  /** `geo.read` yo'q — ro'yxat umuman ochilmadi */
  forbidden: boolean
}

const entrySchema = z.object({ id: uuidSchema, name: z.string() })

const listSchema = z.object({
  rows: z.array(entrySchema),
  total: z.number().nullish(),
  hasNext: z.boolean().nullish(),
})

/** Bir so'rovda olinadigan chegara — sahifalash tanlov ro'yxatida ma'nosiz */
const OPTIONS_SIZE = 300

const EMPTY_FORBIDDEN: GeoOptions = { options: [], truncated: false, forbidden: true }

function isForbidden(error: unknown): boolean {
  return axios.isAxiosError(error) && error.response?.status === 403
}

async function fetchOptions(
  path: string,
  params: Record<string, unknown>,
  signal: AbortSignal,
): Promise<GeoOptions> {
  try {
    const response = await api.get<unknown>(path, {
      signal,
      params: { activeOnly: true, page: 0, size: OPTIONS_SIZE, sort: 'name,asc', ...params },
    })
    const parsed = listSchema.parse(response.data)
    return {
      options: parsed.rows.map((row) => ({ id: row.id, name: row.name })),
      truncated: parsed.hasNext ?? (parsed.total ?? 0) > parsed.rows.length,
      forbidden: false,
    }
  } catch (error) {
    if (isForbidden(error)) return EMPTY_FORBIDDEN
    throw error
  }
}

export function fetchRegionOptions(signal: AbortSignal): Promise<GeoOptions> {
  return fetchOptions('/api/regions', {}, signal)
}

export function fetchDistrictOptions(regionId: string, signal: AbortSignal): Promise<GeoOptions> {
  return fetchOptions('/api/districts', { regionId }, signal)
}

export const contactGeoKeys = {
  regions: ['partner', 'geo', 'regions'] as const,
  districts: (regionId: string) => ['partner', 'geo', 'districts', regionId] as const,
}
